import React from 'react';

interface FeedbackModalProps {
  isVisible: boolean;
  onYes: () => void;
  onNo: () => void;
  isSecondModal?: boolean; 
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({ isVisible, onYes, onNo, isSecondModal = false }) => {
  if (!isVisible) return null;

  return (
    <div className="feedback-modal-overlay">
      <div className="feedback-modal">
        <div className="modal-title-wrapper">
          <h2 className="modal-title">
            {isSecondModal
              ? "What helps you stay consistent long-term?"
              : "What kind of results matter most to you right now?"
            }
          </h2>
        </div>
        <div className="modal-button-wrapper">
          <button className="modal-option-button" onClick={onYes}>
            <span>{isSecondModal ? "Structure" : "Visible"}</span>
          </button>
          <button className="modal-option-button" onClick={onNo}>
            <span>{isSecondModal ? "Guidance" : "Internal"}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;